import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const UserNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const UserName = styled.h2`
  font-size: 14px;
`;

export const TimeSince = styled.p`
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  font-family: Inter-Regular;
  font-weight: 400;
`;

export const FollowText = styled.h1`
  font-size: 14px;
  color: rgba(110, 48, 232, 1);
  font-weight: 600;
  font-family: Inter-Bold;
  cursor: pointer;
`;

export const RightTopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export const TopIconWrapper = styled.div`
  cursor: pointer;
`;